import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import styled from 'styled-components';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { LayoutTemplateContentContainer } from '../app/AppViewComponent.styles';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from '../views/Step';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { LandingPageTitle } from './LandingPageTitle';
import { getLandingPageButton } from './getLandingPageText';
import { useLandingPage } from './useLandingPage';
import { useTrackCAM0001Exposure } from '../experiments/cam0001/cam0001Tracking';
import { useTrackAcq0139Exposure } from '../experiments/acq0139/acq0139Tracking';
const EmbeddedHaveAnAccount = styled.div.withConfig({
  displayName: "LandingPageView__EmbeddedHaveAnAccount",
  componentId: "sc-176kln1-0"
})(["", ""], props => props.theme.embedded && `
      margin-top: 1.5rem;
      font-size: 14px;
      margin-bottom: 1.5rem;
    `);

const LandingPageView = () => {
  const stepKey = Step.LandingPage;
  const shouldShowTos = getFlowConfig().shouldShowTosOnLandingPage;
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    shouldUseLayoutTemplate
  } = useLayoutTemplate();
  useExperiment(ExperimentKeys.ACQ0137, TrackWhen.enrolled, true);
  useExperiment(ExperimentKeys.ACQ0138, TrackWhen.enrolled, true);
  useTrackAcq0139Exposure();
  useTrackCAM0001Exposure();

  const Footer = () => {
    return isInstanceOfSignupEmbedder ? /*#__PURE__*/_jsxs(EmbeddedHaveAnAccount, {
      className: "text-center",
      children: [/*#__PURE__*/_jsx(HaveAnAccountLink, {}), /*#__PURE__*/_jsx(PrivacyBanner, {})]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTos && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    });
  };

  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [/*#__PURE__*/_jsx(LandingPageTitle, {
          isMobile: isMobile
        }), /*#__PURE__*/_jsxs(LayoutTemplateContentContainer, {
          shouldRestrictWidth: true,
          shouldUseLayoutTemplate: shouldUseLayoutTemplate,
          children: [/*#__PURE__*/_jsx(OAuthSignupSection, {}), /*#__PURE__*/_jsx(SignupDataInputForm, {
            autoFocus: false,
            buttonProps: {
              label: getLandingPageButton()
            },
            dataKey: Data.Email,
            inputMode: 'email',
            shouldTrimData: true,
            submit: chooseEmailSignUp
          }, Data.Email), /*#__PURE__*/_jsx(Footer, {})]
        })]
      })
    })
  });
};

export default LandingPageView;